import { useAtom } from "jotai";
import type { WritableAtom } from "jotai";
import NumberFormat from "react-number-format";
import * as React from "react";
import { Label } from "./step2";
import clsx from "clsx";

export function PredefinedField(props: {
  atom: WritableAtom<number, number>;
  title: string;
  tooltip?: string;
  text: string;
  index: number;
}) {
  const [members, setMembers] = useAtom(props.atom);
  return (
    <div
      className={clsx("atc-row", {
        "atc-row--light-bg": props.index % 2 === 1
      })}
    >
      <Label
        label={props.title}
        description={props.text}
        tooltip={props.tooltip}
      />
      <NumberFormat
        className="at-input at-input--border"
        thousandSeparator={"."}
        decimalSeparator={","}
        value={members}
        onValueChange={values => {
          const { value } = values;
          setMembers(Number(value));
        }}
      />
    </div>
  );
}
